import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconUser: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.21071 1.37267C7.64938 0.809909 6.86536 0.5 6 0.5C5.13002 0.5 4.34341 0.808034 3.78468 1.36732C3.21988 1.93276 2.9447 2.70124 3.00931 3.53105C3.13739 5.16819 4.47898 6.49997 6 6.49997C7.52102 6.49997 8.86031 5.16845 8.9904 3.53159C9.05588 2.70927 8.77896 1.9424 8.21071 1.37267Z" />
      <path d="M11.0768 12.4999H0.923216C0.65407 12.5032 0.397666 12.3937 0.225159 12.2018C0.0376639 11.9937 -0.0379109 11.7095 0.0180491 11.4221C0.261504 10.168 1.02129 9.1145 2.21549 8.37495C3.27642 7.71844 4.62033 7.3571 6 7.3571C7.37967 7.3571 8.72358 7.71871 9.78451 8.37495C10.9787 9.11424 11.7385 10.1677 11.982 11.4218C12.0379 11.7092 11.9623 11.9934 11.7748 12.2015C11.6024 12.3935 11.346 12.5031 11.0768 12.4999Z" />
    </svg>
  </IconStyled>
);

IconUser.defaultProps = iconDefaultProps;
IconUser.displayName = 'IconUser';

export default IconUser;
